import { FC, useContext } from 'react';
import { getLocaleDate } from 'utils/time';
import { ReviewPageContext } from '.';
import { Container } from './components';

const NoAnswer: FC = () => {
  const { interview } = useContext(ReviewPageContext);
  
  const isMenteeProposal = interview?.authorId === interview?.mentorship?.menteeId;

  return (
    <Container>
      {isMenteeProposal ? (
        <>
          <p>
            Vous aviez proposé un entretien à la date du{' '}
            {interview?.date && getLocaleDate(interview.date)}, mais votre mentor n'a pas pu répondre à temps.
          </p>
          <p>
            N'hésitez pas à le relancer ou à proposer un nouveau créneau.
          </p>
        </>
      ) : (
        <>
          <p>
            Un entretien avait été planifié par votre mentor à la date du{' '}
            {interview?.date && getLocaleDate(interview.date)}, mais vous n'avez pas répondu à temps.
          </p>
          <p>
            Veillez à vérifier régulièrement votre boîte spam pour ne pas manquer
            les propositions d'entretien de votre mentor.
          </p>
        </>
      )}
    </Container>
  );
};

export default NoAnswer;